import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const c = landingPages["fractional-cmo-bordeaux"]!.en!;

export const Route = createFileRoute("/en/fractional-cmo-bordeaux")({
  head: () =>
    pageHead({
      path: "/en/fractional-cmo-bordeaux",
      title: c.title,
      description: c.description,
      crumbs: [["Fractional CMO Bordeaux", "/en/fractional-cmo-bordeaux"]],
      schemas: landingSchemas(c),
    }),
  component: () => <LandingPage pageKey="fractional-cmo-bordeaux" forceLanguage="en" pathOverride="/en/fractional-cmo-bordeaux" />,
});
